import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/gfx-about.jpg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "970",
  height: "252"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "main-content" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Testimonials"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("table", {
    width: "100%",
    border: "0",
    cellspacing: "0",
    cellpadding: "11"
  }, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", { bgcolor: "#069" }, [
        /*#__PURE__*/_createElementVNode("h2", { style: {"color":"#FFF"} }, "Feedback on Moksha Consulting")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createTextVNode(" Your contribution has been invaluable and we could not have gotten this far without you. It was a difficult brief, with short time lines and us not being 100% certain of what we needed. You helped us focus, brought the expertise we needed and applied just enough pressure to make sure it got done in time. You also helped us deal with some difficult questions within the group, which means we are ready to move forward. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("strong", null, "Karien – COO (2012)"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Our industry is small and Chris' name repeatedly came up in discussions with other industry players as somebody who had added credible input to their companies, both at a strategic and implementation level. Chris delivered on his mandate for us, and his work was both professional and insightful."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("strong", null, "Chris – Director (2011)")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" I found Chris to be deeply knowledgeable about the industry, its participants and market behaviour. He was thoroughly professional in his approach and application. I would recommend him strongly for strategic engagements."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("strong", null, "Antony – CEO (2011)")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Chris' mind is sharper than a Samurai sword & he has a deep, inner balance that keeps him at the calm centre of any corporate storm. Lao Tzu says a good leader displays the twin qualities of compassion & detachment & for me, this sums up Chris. He can put together a new project, analyse what is right & wrong with an existing business & know when something is beyond repair."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("strong", null, "Mike – MD (2010)")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" I have always found him courteous but forthright in his opinions and someone I enjoy bouncing ideas off to get carefully thought out and unambiguous responses."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("strong", null, "Dave – Partner (2010)")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" I can vouch for Chris's strong moral character and integrity from experience with him over many years as a professional colleague, business partner and friend. He is responsible and active in his community."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("strong", null, "Justin – Colleague (2010)")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2
  ], 64))
}